<template>
    <el-dialog class="dialog-container" :visible.sync="dialog" :close-on-click-modal="false"
        :close-on-press-escape="false" :before-close="cancel" :title="title" center>
        <div class="qrcode flex justify-center  padding">
            <div class="flex flex-direction">
                <qrcode v-if="url_1" :size="250" :text="url_1">
                </qrcode>
                <div class="tips self-center">活动志愿者报名二维码</div>
            </div>
            <div class="flex flex-direction">
                <qrcode v-if="url_2" :size="250" :text="url_2">
                </qrcode>
                <div class="tips self-center">活动居民报名二维码</div>
            </div>
            <div class="flex flex-direction">
                <qrcode v-if="url_3" :size="250" :text="url_3">
                </qrcode>
                <div class="tips self-center">活动签到二维码</div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import Qrcode from 'vue-qr'

export default {
    name: "QrDialog",
    components: {
        Qrcode
    },
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
        },
        aid: {
            type: String,
        }
    },
    computed: {
        url_1() {
            return `http://sjf.pc.emof.cn/h5/pages/active/apply1?id=${this.aid}`
        },
        url_2() {
            return `http://sjf.pc.emof.cn/h5/pages/active/apply2?id=${this.aid}`
        },
        url_3() {
            return `http://sjf.pc.emof.cn/h5/pages/active/signIn?id=${this.aid}`
        }
    },
    data() {
        return {
        }
    },
    methods: {
        cancel() {
            this.$emit('watchState', false)
        }
    },
    watch: {
        dialog() {
        }
    }
}
</script>

<style scoped lang="scss">
.qrcode {

    .tips {
        font-size: 16px;
        margin: 30px;
    }
}
</style>